import { tw as a } from "../../utils/tailwind.js";
var d = /* @__PURE__ */ ((r) => (r.Medium = "medium", r.Large = "large", r))(d || {}), w = /* @__PURE__ */ ((r) => (r.ExtraSmall = "extra-small", r.Small = "small", r.Medium = "medium", r.Large = "large", r.ExtraLarge = "extra-large", r))(w || {});
const l = {
  "extra-small": a`w-160`,
  small: a`w-160 md:w-256`,
  medium: a`w-256 md:w-[22rem]`,
  large: a`w-256 md:w-448`,
  "extra-large": a`w-256 md:w-[34rem]`
}, o = {
  narrow: a`w-160`,
  standard: a`w-256`
}, s = {
  narrow: a`md:w-160`,
  standard: a`md:w-256`,
  wide: a`md:w-[22rem]`,
  wider: a`md:w-448`,
  widest: a`md:w-[34rem]`
};
var e = /* @__PURE__ */ ((r) => (r.Narrow = "narrow", r.Standard = "standard", r.Wide = "wide", r.Wider = "wider", r.Widest = "widest", r))(e || {}), t = /* @__PURE__ */ ((r) => (r.Narrow = "narrow", r.Standard = "standard", r))(t || {});
const g = 600;
export {
  e as DesktopWidthEnum,
  d as HeadingSizesEnum,
  t as MobileWidthEnum,
  g as SCROLL_ANNOUNCEMENT_DELAY,
  w as SizesEnum,
  l as cardWidths,
  s as desktopCardWidths,
  o as mobileCardWidths
};
